var _jsxFileName = "/Users/vincent.limshowchen/Sites/account-components/src/components/FieldPass/Header.js";
var _excluded = ["closeLabel", "componentKey", "onBack", "onClose", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import Button from "@mlb/react-patterns/dist/components/Button/button";
import { ButtonShapes, ButtonSizes, ButtonStyles } from "@mlb/react-patterns/dist/components/Button/button.types";
import COLORS from "@mlb/react-patterns/dist/style/universal.color";
import React from "react";
import styled from "styled-components";
import { FieldPassCloseReasons } from "./index";
export var HeaderContainer = styled.div.withConfig({
  displayName: "Header__HeaderContainer",
  componentId: "sc-x8gi5i-0"
})(["border-bottom:1px solid ", ";display:grid;grid-template:\"backButton title closeButton\" / 65px minmax(0,1fr) 65px;height:62px;place-items:center;"], COLORS.mlbGrey2);
var StyledButton = styled(Button).attrs({
  iconHoverColor: COLORS.mlbBlack,
  shape: ButtonShapes.HOLLOW_BORDERLESS,
  size: ButtonSizes.LARGE,
  styleName: ButtonStyles.GREY
}).withConfig({
  displayName: "Header__StyledButton",
  componentId: "sc-x8gi5i-1"
})(["height:100%;padding:0;width:100%;&[data-focus-visible-added]{background:none;box-shadow:inset 0 0 0 3px rgba(0,137,255,0.65);outline:none;}&:hover{background:none;}"]);
var BackButton = styled(StyledButton).withConfig({
  displayName: "Header__BackButton",
  componentId: "sc-x8gi5i-2"
})(["border-radius:8px 0 0 0;grid-area:backButton;"]);
var Title = styled.div.withConfig({
  displayName: "Header__Title",
  componentId: "sc-x8gi5i-3"
})(["font-size:17px;font-weight:bold;grid-area:title;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
var CloseButton = styled(StyledButton).withConfig({
  displayName: "Header__CloseButton",
  componentId: "sc-x8gi5i-4"
})(["border-radius:0 8px 0 0;grid-area:closeButton;"]);
var Header = function Header(_ref) {
  var closeLabel = _ref.closeLabel,
    componentKey = _ref.componentKey,
    onBack = _ref.onBack,
    onClose = _ref.onClose,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  var dataAttrBackButton = {
    "data-testid": "".concat(componentKey, "__back-button")
  };
  var dataAttrCloseButton = {
    "data-testid": "".concat(componentKey, "__close-button")
  };
  var onClick = function onClick(event) {
    return onClose({
      event: event,
      reason: FieldPassCloseReasons.CLOSE_BUTTON_CLICK
    });
  };
  return /*#__PURE__*/React.createElement(HeaderContainer, _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78,
      columnNumber: 5
    }
  }), onBack && /*#__PURE__*/React.createElement(BackButton, {
    dataAttr: dataAttrBackButton,
    handlers: {
      onClick: onBack
    },
    iconName: "arrow-previous",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Title, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 7
    }
  }, title), /*#__PURE__*/React.createElement(CloseButton, {
    dataAttr: dataAttrCloseButton,
    handlers: {
      onClick: onClick
    },
    iconName: "close",
    ariaLabel: closeLabel,
    ariaPressed: null,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 7
    }
  }));
};
export default /*#__PURE__*/React.memo(Header);